import { useEffect, useState } from "react";
import { Api } from "services/api/api.service";

interface UseNonWorkingDaysParams {
  companyId: number | null;
  year: number;
  includeWeekends: boolean;
}

/**
 * Load non-working day keys (YYYY-MM-DD) for a company/year.
 */
export const useNonWorkingDays = (
  params: UseNonWorkingDaysParams,
): ReadonlySet<string> => {
  const [nonWorkSet, setNonWorkSet] = useState<Set<string>>(new Set());

  useEffect(() => {
    let isActive = true;
    const companyId = params.companyId;
    if (companyId == null)
      return () => {
        isActive = false;
      };
    (async (): Promise<void> => {
      try {
        const response = await Api().company.gig.getNonWorkDays(
          companyId,
          params.year,
          params.includeWeekends,
        );
        const keys = response.data.filter(isIsoDateString);
        if (!isActive) return;
        setNonWorkSet(new Set(keys));
      } catch {
        if (!isActive) return;
        setNonWorkSet(new Set());
      }
    })();

    return () => {
      isActive = false;
    };
  }, [params.companyId, params.includeWeekends, params.year]);

  return nonWorkSet;
};

const isIsoDateString = (value: string): boolean =>
  /^\d{4}-\d{2}-\d{2}$/.test(value);
